<template>
  <div>
    <div class="tabs">
      <div class="tab"
           :class="{active: current === tab}"
           v-for="(tab, index) in tabs"
           :key="`tab-${index}`"
           @click.prevent="change(tab)"
      >{{ tab.title }}
      </div>
    </div>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      tabs: [],
      current: null
    }
  },
  methods: {
    change(tab) {
      this.current = tab;
      this.tabs.forEach(function (_t) {
        _t.active = _t === tab;
      });
    },
    registerTab(tab) {
      if (!this.current) {
        this.current = tab;
      }
      this.tabs.push(tab);
    }
  }
}
</script>